
















import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue'
import ContractItem from '@/domain/contract/entity/contract-item.entity';

@Component({
  components: {
    VbTooltipSlot,
  },
})
export default class PerformObservationButton extends Vue {
  @Prop() contractItem!: ContractItem;

  @Prop() disabled!: boolean;

  @Prop({ default: false }) hasInstances!: boolean;

  @Prop({ default: false }) isAllowFakeInstance!: boolean;

  get hasCalculation() {
    return this.contractItem.hasCalculationRules;
  }

  get tooltipText() {
    if (this.isFake()) return 'Executar faturamento com instância fictícia';
    return this.hasCalculation ? 'Executar Faturamento' : 'Cálculo Inconsistente';
  }

  isFake() {
    if (this.hasInstances) return false;
    return this.isAllowFakeInstance;
  }

  @Emit('click')
  private click(): void {}
}
